import { render, staticRenderFns } from "./FunctionGroup.vue?vue&type=template&id=18aa980e"
import script from "./FunctionGroup.vue?vue&type=script&lang=js"
export * from "./FunctionGroup.vue?vue&type=script&lang=js"
import style0 from "./FunctionGroup.vue?vue&type=style&index=0&id=18aa980e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports